import React from "react";
import fieldPropTypes from "./field-prop-types";

const FormBullet = ({
  field: { title, text, color },
  components: { Bullet }
}) => <Bullet {...{ title, text, color }} />;

FormBullet.propTypes = fieldPropTypes;

export default FormBullet;
